import { GetterTree } from 'vuex';
import { ContractState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ContractState, RootState> = {
  isContractAccepted: (state, getters) => {
    return state.isAccepted;
  },
  contractHtml: (state, getters) => {
    return state.contractHtml;
  },
};

export default getters;
